var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardCancelSuspended = function SvgCardCancelSuspended(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.433 15.212-.83-.83V9.086h-5.296L9.7 6.48h7.903V4.71a.28.28 0 0 0-.08-.206.28.28 0 0 0-.207-.081H7.643L6.429 3.208h10.887c.42 0 .775.145 1.066.436.29.29.435.645.435 1.065v9.508c0 .194-.03.374-.089.539-.06.165-.158.317-.295.456ZM8.228 9.086H3.039v5.131c0 .072.03.138.09.198s.126.09.198.09h10.32L8.227 9.085ZM18.165 19l-3.305-3.282H3.327c-.42 0-.776-.145-1.066-.435a1.45 1.45 0 0 1-.435-1.067V4.703c0-.42.143-.775.428-1.063a1.421 1.421 0 0 1 1.05-.432h.762L5.42 4.562H3.327a.275.275 0 0 0-.198.09.275.275 0 0 0-.09.197v1.63h2.582L1 1.835 1.858 1 19 18.142l-.835.858Z",
    fill: "#E53611"
  })));
};
export default SvgCardCancelSuspended;